import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { ChangePassword, ConfirmEmail, DocumenDto, VendorDto, VendorModel } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { first, lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { CountryMaster } from 'src/app/shared/models/app.models';
import { FormUtils } from 'src/app/shared/helpers/utils.helper'; // Adjust the path as necessary
import { AuthenticationActions } from '../models/authentication-actions.enum';
import { Utils } from 'src/app/shared/helpers/utils.helper';
import { countryCodes } from 'src/app/shared/data/countries';
import { ToastService } from 'src/app/shared/services/toast.service';





@Component({
  selector: 'app-vendor-registration',
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.scss', '../../../authentication/components/authentication/authentication.component.scss']
})


export class VendorRegistrationComponent implements OnInit {
  countryCodes = countryCodes;
  returnUrl;
  translations = en;
  invalidSubmit = false;
  email: string | null;
  AppConstants = AppConstants;
  ShowRegisterBtn: boolean = true;
  isVaildiateBtnDisabled: boolean = false;
  _PersonalInfoForm: FormGroup;
  countries: CountryMaster[] = []; // To store fetched countries
  selectedCountry: string; // To store the selected country

  accountInfoForm: FormGroup;
  isOrganization = false;
  isRegisteredInQNBN = false;
  isLocal = true; // Track if Local or Foreign is selected
  isAccountExisting = false; // Track if account is existing
  currentTab: number = 0;
  steps: { title: string }[] = [
    { title: 'Personal Info' },
    { title: 'Account Info' },
  ];
  // Flag to show/hide QNBN registration question section (no longer used – kept for compatibility)
  showQNBNQuestion: boolean = false;


  public get PersonalInfoForm(): FormGroup {
    return this._PersonalInfoForm;
  }
  //#endregion
  //#region setters
  public set PersonalInfoForm(value: FormGroup) {
    this._PersonalInfoForm = value;
  }


  constructor(
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {

    this._loaderService.showLoader();

    this.initialize();

    const apiService = new ApiService(this._http);  // Manual creation, as per your preference
    apiService.loadAllLookups().then(() => {
      this.countries = apiService.countries;  // Access the currencies after lookups are loaded
      // Set Qatar country after countries are loaded
      this.onLocalOrForeignChange();
    }).catch(error => {
      console.error('Failed to load lookups:', error);
    });


    this._activeRoute.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];

      const reference = params['reference'];
      if (reference) {
        // Preselect QNBN registration and reference from URL, then auto-validate
        this.PersonalInfoForm.patchValue({
          registeredInQNBN: 'Yes',
          VendorReference: reference
        });
        this.onRegisteredInQNBNChange();
        this.onValidateClick();
      }
    });
    this._loaderService.hideLoader();

  }



  private initialize() {
    this.initializeForm();
  }

  private initializeForm() {
    this._PersonalInfoForm = this._formBuilder.group({
      registeredInQNBN: ['No', Validators.required],
      vendorType: ['Organization', Validators.required],
      LocalOrForeign: ['local', Validators.required],
      Email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      VendorReference: [''],
    }, { validator: this.ConfirmAndPassMatchesAndStrength.bind(this) });


    this.accountInfoForm = this._formBuilder.group({

      registeredInQNBN: [''],
      isAccountExisting: ['No',],
      VendorReference: [''], // Reference number for existing account
      singlePointOfContact: ['', Validators.required],
      VendorName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      crNumber: [''],
      qatid: [''],
      passport: [''],
      commercialRegistrationNumber: [''],
      CountryRegionIdPrimary: ['', Validators.required],
      Mobile: ['', [Validators.required, Validators.pattern('^\\+?[1-9]\\d{1,14}$')]],
      MobileCode: ['+974'],
      Errors: [],
    });

    // Initialize Local/Foreign state and vendor type
    this.isLocal = true; // Default is 'local'
    this.isAccountExisting = false; // Default is 'No' (false)
    
    // Ensure default value is set for isAccountExisting
    this.accountInfoForm.get('isAccountExisting')?.setValue('No', { emitEvent: false });
    
    this.onSignInAsChange(); // Initialize organization state
    this.onLocalOrForeignChange();
    this.onAccountExistingChange(); // Initialize account existing state

    if (environment.DISABLE_BACKEND) {
      this.PersonalInfoForm.patchValue({
        Email: 'newvendor@demo.qa',
        password: 'Demo@123',
        confirmPassword: 'Demo@123'
      });
      this.accountInfoForm.patchValue({
        singlePointOfContact: 'Layla Al-Harbi',
        VendorName: 'Qatar Demo Technologies W.L.L.',
        crNumber: 'CR-2026-78451',
        CountryRegionIdPrimary: 'QA',
        MobileCode: '+974',
        Mobile: '55501234'
      });
    }

  }


  onSignInAsChange() {
    const signInAs = this.PersonalInfoForm.get('vendorType')?.value;
    this.isOrganization = signInAs === 'Organization' || signInAs === 'Investor';
    // this.isOrganization = signInAs === 'Organization'; // Investor removed - uncomment above line to enable Investor

    if (this.isOrganization) {
      this.accountInfoForm.get('singlePointOfContact')?.setValidators(Validators.required);
      this.accountInfoForm.get('VendorName')?.setValidators(Validators.required);
      this.accountInfoForm.get('firstName')?.clearValidators();
      this.accountInfoForm.get('lastName')?.clearValidators();
    } else {
      this.accountInfoForm.get('singlePointOfContact')?.clearValidators();
      this.accountInfoForm.get('VendorName')?.clearValidators();
      this.accountInfoForm.get('firstName')?.setValidators(Validators.required);
      this.accountInfoForm.get('lastName')?.setValidators(Validators.required);
    }

    this.accountInfoForm.get('singlePointOfContact')?.updateValueAndValidity();
    this.accountInfoForm.get('VendorName')?.updateValueAndValidity();
    this.accountInfoForm.get('firstName')?.updateValueAndValidity();
    this.accountInfoForm.get('lastName')?.updateValueAndValidity();

    // Update Local/Foreign fields based on vendor type change
    this.onLocalOrForeignChange();
  }

  onRegisteredInQNBNChange() {
    const registeredInQNBN = this.PersonalInfoForm.get('registeredInQNBN')?.value;
    this.isRegisteredInQNBN = registeredInQNBN === 'Yes';

    if (this.isRegisteredInQNBN) {


      this.PersonalInfoForm.get('VendorReference')?.setValidators([Validators.required]);



      this.ShowRegisterBtn = true;

    } else {


      this.PersonalInfoForm.get('VendorReference')?.clearValidators();

      this.mapResponseToForm(null);



      this.ShowRegisterBtn = true;
    }
    this.PersonalInfoForm.get('VendorReference')?.updateValueAndValidity();

  }

  onAccountExistingChange() {
    const isAccountExistingValue = this.accountInfoForm.get('isAccountExisting')?.value;
    this.isAccountExisting = isAccountExistingValue === 'Yes';

    if (this.isAccountExisting) {
      this.accountInfoForm.get('VendorReference')?.setValidators([Validators.required]);
    } else {
      this.accountInfoForm.get('VendorReference')?.clearValidators();
      this.accountInfoForm.get('VendorReference')?.setValue('');
    }
    this.accountInfoForm.get('VendorReference')?.updateValueAndValidity();
  }

  onLocalOrForeignChange() {
    const localOrForeign = this.PersonalInfoForm.get('LocalOrForeign')?.value;
    const vendorType = this.PersonalInfoForm.get('vendorType')?.value;
    this.isLocal = localOrForeign === 'local';
    const isIndividual = vendorType === 'Individual';

    if (this.isLocal) {
      // Hide Passport
      this.accountInfoForm.get('passport')?.clearValidators();
      this.accountInfoForm.get('passport')?.setValue('');

      if (isIndividual) {
        // Individual + Local: Show QATID, hide CR Number
        this.accountInfoForm.get('qatid')?.setValidators([Validators.required]);
        this.accountInfoForm.get('crNumber')?.clearValidators();
        this.accountInfoForm.get('crNumber')?.setValue('');
      } else {
        // Organization + Local: Show CR Number, hide QATID
        this.accountInfoForm.get('crNumber')?.setValidators([Validators.required]);
        this.accountInfoForm.get('qatid')?.clearValidators();
        this.accountInfoForm.get('qatid')?.setValue('');
      }

      // Set Country to Qatar and disable it
      if (this.countries && this.countries.length > 0) {
        const qatarCountry = this.countries.find(country =>
          country.countryName?.toLowerCase() === 'qatar' ||
          country.countryRegionId === 'QA' ||
          country.countryRegionId?.toUpperCase() === 'QA'
        );
        if (qatarCountry) {
          this.accountInfoForm.get('CountryRegionIdPrimary')?.setValue(qatarCountry.countryRegionId);
          this.accountInfoForm.get('CountryRegionIdPrimary')?.disable();
        }
      } else {
        // If countries not loaded yet, set to 'QA' directly
        this.accountInfoForm.get('CountryRegionIdPrimary')?.setValue('QA');
        this.accountInfoForm.get('CountryRegionIdPrimary')?.disable();
      }
    } else {
      // Foreign: Show Passport for Individual, Commercial Registration Number for Organization
      if (isIndividual) {
        // Individual + Foreign: Show Passport
        this.accountInfoForm.get('passport')?.setValidators([Validators.required]);
        this.accountInfoForm.get('commercialRegistrationNumber')?.clearValidators();
        this.accountInfoForm.get('commercialRegistrationNumber')?.setValue('');
      } else {
        // Organization + Foreign: Show Commercial Registration Number
        this.accountInfoForm.get('commercialRegistrationNumber')?.setValidators([Validators.required]);
        this.accountInfoForm.get('passport')?.clearValidators();
        this.accountInfoForm.get('passport')?.setValue('');
      }

      // Hide CR Number and QATID for Foreign
      this.accountInfoForm.get('crNumber')?.clearValidators();
      this.accountInfoForm.get('crNumber')?.setValue('');
      this.accountInfoForm.get('qatid')?.clearValidators();
      this.accountInfoForm.get('qatid')?.setValue('');

      // Enable Country field for Foreign
      this.accountInfoForm.get('CountryRegionIdPrimary')?.enable();
      // Clear the value to allow selection
      this.accountInfoForm.get('CountryRegionIdPrimary')?.setValue('');
    }

    this.accountInfoForm.get('crNumber')?.updateValueAndValidity();
    this.accountInfoForm.get('qatid')?.updateValueAndValidity();
    this.accountInfoForm.get('passport')?.updateValueAndValidity();
    this.accountInfoForm.get('commercialRegistrationNumber')?.updateValueAndValidity();
  }


  public onValidateClick(): void {

    // Retrieve the value of VendorReference
    const vendorReference = this.PersonalInfoForm.get('VendorReference')?.value;
    const apiService = this.createApiService();


    if (!Utils.IsNullOrWhiteSpace(vendorReference)) {
      this._loaderService.showLoader();
      this.fireGetGetVendorByReferenceNo(apiService, vendorReference).then((response: any) => {
        let result = response as unknown as BaseResponseDTO;

        if (result.isSuccess) {
          console.log(result.data);
          this.ShowRegisterBtn = true;
          // Do not disable any controls for auto-fill scenario
          this.mapResponseToForm(result.data, false);
        } else {
          this.ShowRegisterBtn = false;
          this.toastService.error(result.errorMessageEn);
          this.formValidationService.setCustomError(this.accountInfoForm.get('VendorReference'), result.errorMessageEn);
        }
      }).finally(() => {
        this._loaderService.hideLoader();
      });




    }
  }

  public onValidateAccountReferenceClick(): void {
    // Retrieve the value of VendorReference from accountInfoForm
    const vendorReference = this.accountInfoForm.get('VendorReference')?.value;
    const apiService = this.createApiService();


    if (!Utils.IsNullOrWhiteSpace(vendorReference)) {
      this._loaderService.showLoader();
      this.fireGetGetVendorByReferenceNo(apiService, vendorReference).then((response: any) => {
        let result = response as unknown as BaseResponseDTO;

        if (result.isSuccess) {
          console.log(result.data);
          this.mapResponseToForm(result.data);
          this.toastService.success('Reference number validated successfully');
        } else {
          this.formValidationService.setCustomError(this.accountInfoForm.get('VendorReference'), result.errorMessageEn || 'Code is not-Valid');
          this.toastService.error(result.errorMessageEn || 'Code is not-Valid');
        }
      }).finally(() => {
        this._loaderService.hideLoader();
      });
    } else {
      this.formValidationService.setCustomError(this.accountInfoForm.get('VendorReference'), 'Please enter a reference number');
    }
  }

  private mapResponseToForm(data: any, disableControls: boolean = true): void {
    // Check if data is null and reset/enable all controls if true
    if (data === null) {

      this.accountInfoForm.reset({
        isAccountExisting: 'No',
        singlePointOfContact: null,
        VendorName: null,
        firstName: null,
        lastName: null,
        crNumber: null,
        qatid: null,
        passport: null,
        commercialRegistrationNumber: null,
        CountryRegionIdPrimary: null,
        MobileCode: '+974'
      });

      Object.keys(this.accountInfoForm.controls).forEach(key => {
        this.accountInfoForm.get(key)?.enable();
      });

      this._PersonalInfoForm.get('VendorReference')?.setValue(null);
      this._PersonalInfoForm.get('VendorReference')?.enable();
      this._PersonalInfoForm.get('vendorType')?.enable();
      this._PersonalInfoForm.get('LocalOrForeign')?.enable();
      this.isVaildiateBtnDisabled = false;
      
      // Update account existing state after reset
      this.onAccountExistingChange();
      
      return; // Exit the function early
    }

    // Normal processing if data is not null
    this._PersonalInfoForm.patchValue({
      vendorType: data.vendorType || null,
      LocalOrForeign: data.localOrForeign || null,
      Email: data.email || data.Email || null,
    });

    this.accountInfoForm.patchValue({
      singlePointOfContact: data.firstName || null,
      VendorName: data.vendorName || null,
      firstName: data.firstName || null,
      lastName: data.lastName || null,
      crNumber: data.crNumber || null,
      qatid: data.qatid || null,
      passport: data.passport || null,
      commercialRegistrationNumber: data.commercialRegistrationNumber || null,
      CountryRegionIdPrimary: data.countryRegionIdPrimary || null,
    });

    if (disableControls) {
      Object.keys(this.accountInfoForm.controls).forEach(key => {
        if (key !== 'Mobile' && key !== 'registeredInQNBN' && key !== 'MobileCode') {
          const control = this.accountInfoForm.get(key);
          if (control?.value != null) {
            control.disable();
          } else {
            control?.enable();
          }
        }
      });

      // Set 'VendorReference' disabled state based on its value
      if (this._PersonalInfoForm.get('VendorReference')?.value != null) {
        this._PersonalInfoForm.get('VendorReference')?.disable();
      } else {
        this._PersonalInfoForm.get('VendorReference')?.enable();
      }

      // Check if 'vendorType' and 'LocalOrForeign' should be disabled
      if (data.vendorType != null) {
        this._PersonalInfoForm.get('vendorType')?.disable();
      } else {
        this._PersonalInfoForm.get('vendorType')?.enable();
      }
      if (data.localOrForeign != null) {
        this._PersonalInfoForm.get('LocalOrForeign')?.disable();
      } else {
        this._PersonalInfoForm.get('LocalOrForeign')?.enable();
      }

      this.isVaildiateBtnDisabled = true;
    }
  }



  public isFormValid(): boolean {
    return (
      FormUtils.isVisibleFormValid(this._PersonalInfoForm) &&
      FormUtils.isVisibleFormValid(this.accountInfoForm)
    );
  }



  private ConfirmAndPassMatchesAndStrength(frm: FormGroup) {

    const passwordControl = frm.controls['password'];
    const confirmPasswordControl = frm.controls['confirmPassword'];


    confirmPasswordControl.setErrors(null);

    const password = passwordControl.value;
    const confirmPassword = confirmPasswordControl.value;



    const isValid = password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[^a-zA-Z0-9]/.test(password);

    if (!isValid) {

      this.formValidationService.setCustomError(frm.controls['confirmPassword'], this.translations.common.PasswordStrength);
      return false;
    }

    if (password !== confirmPassword) {
      this.formValidationService.setCustomError(frm.controls['confirmPassword'], this.translations.common.ConfirmedPassdontMatch);
      return false;
    }

    return true;
  }

  onNext(): void {
    if (this._PersonalInfoForm.valid) {
      const email = this._PersonalInfoForm.get('Email')?.value; // Get the email from the form control

      // Check if the email is already in use
      this.onCheckEmail(email).then(result => {

        if (result) {
          this.toastService.error("Email Already in use");
          this.formValidationService.setCustomError(this.PersonalInfoForm.get('Email'), "Email Already in use");
          console.error('Email is already in use.');
        } else {
          // Email is not in use, proceed to the next tab
          this.currentTab = 1; // Go to the next tab
          this.onSignInAsChange();
          this.onRegisteredInQNBNChange();
          this.onLocalOrForeignChange();
        }
      }).catch(error => {
        console.error('Error checking email:', error);
      });

    } else {
      this.markFormGroupTouched(this._PersonalInfoForm);
    }
  }

  public onSubmitForm(event: Event) {


    event.preventDefault();
    this.invalidSubmit = false;

    if (this.isFormValid()) {
      let perosnalData = this._PersonalInfoForm.getRawValue();
      let AccountData = this.accountInfoForm.getRawValue();

      if (AccountData.singlePointOfContact != null && AccountData.singlePointOfContact != undefined && AccountData.singlePointOfContact != "") {
        perosnalData.ContactPerson = [
          {
            "FirstName": AccountData.singlePointOfContact,
          }
        ];
      }

      // Prefer the reference coming from the personal-info step (URL flow),
      // but allow the account-info reference to override only when it has a value.
      const personalReference = perosnalData.VendorReference;
      const accountReference = AccountData.VendorReference;

      const mergedData = {
        ...perosnalData,
        ...AccountData,
        VendorReference: personalReference || accountReference
      };
      this.handlesubmission(mergedData);
    } else {
      this.markFormGroupTouched(this.accountInfoForm);
      this.invalidSubmit = true;
    }
  }



  ValidateVendorData(email: string): Promise<boolean> {
    const payload = {
      email: email,
      vendorReference: this.PersonalInfoForm.get('VendorReference')?.value
    };
    const apiService = this.createApiService(); // Assuming you have a method to create the ApiService instance

    let req$ = apiService.get(
      AppConstants.CONTROLLERS.VENDOR,
      AppConstants.ACTIONS.CheckEmailInUse,
      true,
      environment.APIs_PREFIX,
      payload
    );

    return lastValueFrom(req$).then(response => {
      let result = response as unknown as BaseResponseDTO;
      return result.isSuccess;

    }).catch(error => {
      console.error('Error checking email:', error);
      return false;
    });
  }


  onCheckEmail(email: string): Promise<boolean> {
    if (environment.DISABLE_BACKEND) {
      this.PersonalInfoForm.get('Email')?.setErrors(null);
      return Promise.resolve(false);
    }

    this._loaderService.showLoader();
    const payload = {
      email: email,
      vendorReference: this.PersonalInfoForm.get('VendorReference')?.value
    };
    const apiService = this.createApiService(); // Assuming you have a method to create the ApiService instance

    let req$ = apiService.get(
      AppConstants.CONTROLLERS.VENDOR,
      AppConstants.ACTIONS.CheckEmailInUse,
      true,
      environment.APIs_PREFIX,
      payload
    );

    return lastValueFrom(req$).then(response => {
      let result = response as unknown as BaseResponseDTO;
      return result.isSuccess;

    }).catch(error => {
      console.error('Error checking email:', error);
      return false;
    }).finally(() => {
      this._loaderService.hideLoader();
    });
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  //#region API Service
  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }
  //#endregion

  //#region Payloads
  private prepareValidateUserRequestPayload(data: any) {
    return data as VendorModel;
  }
  //#endregion




  public validateVendorData(vendor: VendorModel): Promise<boolean> {
    this._loaderService.showLoader();
    const apiService = this.createApiService(); // Create the API service instance

    // Create the request payload
    const payload = vendor;

    // Fire the HTTP request to validate vendor data
    let req$ = apiService.post(
      AppConstants.CONTROLLERS.VENDOR,
      AppConstants.ACTIONS.ValidateVendorData,
      true,
      environment.APIs_PREFIX,
      payload
    );

    // Return a promise that resolves to true if the data is valid, false otherwise
    return lastValueFrom(req$).then(response => {
      let result = response as unknown as BaseResponseDTO;
      if (!result.isSuccess) {
        this.formValidationService.setCustomError(this.accountInfoForm.get('Errors'), result.errorMessageEn);
      }
      return result.isSuccess; // Return true if the validation was successful
    }).catch(error => {
      console.error('Error validating vendor data:', error);
      return false; // Return false if there was an error or validation failed
    }).finally(() => {
      this._loaderService.hideLoader();
    });

  }

  //#region Fire HTTP Requests
  private fireValidateUserRequest(apiService: ApiService, payload: VendorModel) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.ValidateVendorData, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }

  private fireGetGetVendorByReferenceNo(apiService: ApiService, refNo: string) {
    const payload = { refNo: refNo };
    let req$ = apiService.get(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.GetVendorByReferenceNo, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }


  //#endregion



  private async handlesubmission(data: any) {


    console.log('handleValidateUser called with data:', data);
    const apiService = this.createApiService();
    const payload = this.prepareValidateUserRequestPayload(data);
    const mobileCode = this.accountInfoForm.get('MobileCode')?.value + ' ';
    const mobile = this.accountInfoForm.get('Mobile')?.value;
    payload.mobile = mobileCode + mobile;
    this._userService.email = payload.Email!;
    this._loaderService.showLoader();
    this.validateVendorData(payload)
      .then(isValid => {
        if (isValid) {
          this._userService.setRegistrationData(payload);

          // Navigate to OTP page
          this._router.navigate(
            [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.OTP_Page],
            { queryParams: { action: AuthenticationActions.Register } }
          );
        }
      }).finally(() => {
        this._loaderService.hideLoader();
      });








  }






}


